import React from 'react';

export interface IBaseIconProps {
  icon: DEPRECATED_FA_GLOBAL_SPRITE;
  className?: string;
  size?: SizeProp;
  onClick?: React.MouseEventHandler<SVGSVGElement> | (() => void);
}

type SizeProp = 'xs' | 'lg' | 'sm' | '1x' | '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x';

export enum DEPRECATED_FA_GLOBAL_SPRITE {
  creditCard = 'creditСard',
  uploadCloud = 'uploadCloud',
  checkCircles = 'checkCircles',
  x = 'x',
  edit = 'edit',
  download = 'download',
  trash = 'trash',
  refresh = 'refresh',
  exclamationTriangle = 'exclamationTriangle',
  moreHorizontal = 'moreHorizontal',
  moreHorizontalOpen = 'moreHorizontalOpen',
  link = 'link',
  chevronUp = 'chevronUp',
  chevronDown = 'chevronDown',
  chevronDownSquare = 'chevronDownSquare',
  chevronDownSquareSolid = 'chevronDownSquareSolid',
  chevronUpSquare = 'chevronUpSquare',
  chevronUpSquareSolid = 'chevronUpSquareSolid',
  filter = 'filter',
  filterActive = 'filterActive',
  ban = 'ban',
  copy = 'copy',
  search = 'search',
  backspace = 'backspace',
  clock = 'clock',
  arrowLeft = 'arrowLeft',
  lineChart = 'lineChart',
  /* Document Categories */
  idCard = 'idCard',
  car = 'car',
  passport = 'passport',
  fileInvoiceDollar = 'fileInvoiceDollar',
  fileInvoice = 'fileInvoice',
  house = 'house',
  mobile = 'mobile',
  file = 'file',
  fileSertificate = 'fileSertificat',
  pen = 'pen',
  filePlus = 'filePlus',
  chevronDoubleDown = 'chevronDoubleDown',
  idBadge = 'idBadge',
}
